export const BODY_STYLE = {
  maxHeight: '70rem',
  overflow: 'auto',
};
